import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/angellist': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M347.1 215.4c48 11.7 54.9 50.6 54.9 93.7 0 114.3-73.4 202.9-191.4 202.9-96.2 0-164.6-76.4-164.5-148.6 0-37.1 14.2-61.7 51.1-71.7-3.1-8.3-8-20.8-8-29.7 0-23.5 24.9-52.6 48.3-52.6 6.9 0 13.7 2 20 4.3-12.4-35.2-46.6-126.7-46.6-162 0-28.8 14.6-51.7 45.7-51.7 40 0 85.4 144 95.1 172.5 12.5-31.4 52.5-163.1 97.1-163.1 28 0 43.7 22.3 43.7 48.9 0 30.2-33.7 124.5-45.4 157.1zM311.7 108l-33.1 93.7 34 6c8.5-23.4 47.1-128.9 47.1-148 0-7.1-2.3-16-10.9-16-16 0-33.1 52-37.1 64.3zM142.3 48.3c0 29.1 34.6 120 45.5 148.8 7.7-4.4 19.8-2.7 35.4-1.4l-34.6-100.3c-31.8-92.8-46.3-59-46.3-47.1zM140 244c-7.7 0-20.3 13.4-20.4 21.1 0 20.8 56 97.7 76.9 97.7 5.7 0 10.6-6.3 10.6-11.4 0-12.8-37.8-107.4-67.1-107.4zM324.3 430.3c55.3-61.5 49.1-158.6 31-174.7-24-21.1-106-29.1-138.3-29.1-17.3 0-17.4 6.4-17.4 13.1 0 43.7 92.9 39.7 120.6 39.7 11.2 0 15.8 9.9 16.9 21.1-7.4 7.4-17.7 11.7-27.4 15.4-9.4 3.4-19.1 7.1-27.1 13.1-22 16-43.7 43.4-43.7 71.7 0 17.7 10.6 32.9 10.6 50.3 0 0.3-2 6.5-2 7.4-32.6-2.3-40.6-34.6-41.7-61.7-3.4 0.9-8 0.6-11.7 0.6 5.1 17.8-11.9 42-38 42-37.8 0-88-57.2-58.3-86.9 28.7 35.9 35 51.4 51.1 51.4 4 0 11.7-3.4 11.7-8.3 0-12.8-42.9-73.1-54.3-73.1-16.8 0-37.7 24.9-20.6 68.3 22.6 55.7 69.5 88.3 128.9 88.3 43.4 0 80.6-16.6 109.7-48.6zM225.7 304.3c3.2 8.3 6.6 16.6 9.4 25.1 6.3-7.1 12.9-13.7 20.3-19.1-10-2-20-2.9-29.7-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/angellist.js
// module id = 704
// module chunks = 0